export const SUSPENDED_OPTIONS = [
    {value: '', label: 'All'},
    {value: '1', label: 'Yes'},
    {value: '0', label: 'No'},
];

export const ADVANCED_OPTIONS = [
    {value: '', label: 'All'},
    {value: '1', label: 'Yes'},
    {value: '0', label: 'No'},
];

export const COUNTRY_OPTIONS = [
    {value: '', label: 'All'},
    {value: '1', label: 'Australia'},
    {value: '2', label: 'New Zealand'},
    {value: '3', label: 'United States'},
];

// Values mirror UserInterface::SIGNUP_* in goCabinets and are persisted in
// customer.signUpSource. Always declare them explicitly; never rely on order.
export enum SIGNUP_SOURCES {
    SIGNUP_ADMIN = 0, // added via admin portal
    SIGNUP_MANUFACTURER = 1, // added via manufacturer portal
    SIGNUP_API = 2, // added through api
    SIGNUP_GENERIC_DOMAIN = 3, // added through loginForm.php with no manufacturer domain
    SIGNUP_MANUFACTURER_DOMAIN = 4, // added through loginForm.php with manufacturer domain
    SIGNUP_REMOTE = 5, // added through loginForm.php and the data was POSTed from some other site
    SIGNUP_SUPPLIER = 6, // unused by the UI; kept so the values below match the DB
    SIGNUP_WEBSITE_GOCABINET = 7,
    SIGNUP_GOFLATPACK = 8,
}

export const SIGNUP_SOURCES_OPTIONS = [
    {value: '', label: 'All'},
    {value: SIGNUP_SOURCES.SIGNUP_ADMIN, label: 'Manually added by admin'},
    {
        value: SIGNUP_SOURCES.SIGNUP_MANUFACTURER,
        label: 'Manually added by manufacturer',
    },
    {
        value: SIGNUP_SOURCES.SIGNUP_API,
        label: "From Manufacturer's register API",
    },
    {
        value: SIGNUP_SOURCES.SIGNUP_REMOTE,
        label: 'From manufacturer website (legacy)',
    },
    {
        value: SIGNUP_SOURCES.SIGNUP_MANUFACTURER_DOMAIN,
        label: 'Self-registered on manufacturer domain',
    },
    {
        value: SIGNUP_SOURCES.SIGNUP_GENERIC_DOMAIN,
        label: 'Self-registered on generic domain',
    },
    {
        value: SIGNUP_SOURCES.SIGNUP_WEBSITE_GOCABINET,
        label: 'From gocabinets.com.au',
    },
    {
        value: SIGNUP_SOURCES.SIGNUP_GOFLATPACK,
        label: 'From goFlatpacks',
    },
];
